import { Link, useLocation } from "react-router-dom";

import { AdBanner } from "@/components/ads/AdBanner";
import { Seo } from "@/components/seo/Seo";
import { findSeoRoute } from "@/config/seo.config";

export function LandingPage() {
  const location = useLocation();
  const route = findSeoRoute(location.pathname);

  if (!route) {
    return null;
  }

  return (
    <>
      <Seo
        path={route.path}
        title={route.title}
        description={route.description}
        robots={route.robots}
      />
      <section className="mx-auto max-w-6xl px-4 py-8 sm:px-6 sm:py-10">
        <div className="max-w-3xl">
          <p className="text-sm font-medium uppercase tracking-[0.12em] text-neutral-500">
            {route.label}
          </p>
          <h1 className="mt-3 break-words text-4xl font-semibold tracking-normal sm:text-5xl">
            {route.h1}
          </h1>
          <p className="mt-4 text-base leading-7 text-neutral-600 dark:text-neutral-400">
            {route.intro}
          </p>
          <p className="mt-2 text-sm font-medium text-neutral-800 dark:text-neutral-200">
            Free to start. No login required.
          </p>
          <Link
            to="/"
            className="mt-5 inline-flex h-10 items-center border border-neutral-950 bg-neutral-950 px-4 text-sm font-medium text-white transition hover:bg-white hover:text-neutral-950 dark:border-white dark:bg-white dark:text-neutral-950 dark:hover:bg-neutral-950 dark:hover:text-white"
          >
            Start transcribing
          </Link>
        </div>
      </section>
      <AdBanner slot="midContent" />
      <section className="mx-auto grid max-w-6xl gap-8 px-4 pb-14 sm:px-6 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <h2 className="text-2xl font-semibold">Best for</h2>
          <p className="mt-3 leading-7 text-neutral-600 dark:text-neutral-400">
            {route.audience}
          </p>
        </div>
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl font-semibold">What happens</h2>
            <ol className="mt-4 space-y-3">
              {route.howItWorks.map((item, index) => (
                <li
                  key={item}
                  className="grid grid-cols-[32px_1fr] gap-3 text-sm leading-6"
                >
                  <span className="flex h-8 w-8 items-center justify-center border border-neutral-300 font-mono text-xs dark:border-neutral-700">
                    {index + 1}
                  </span>
                  <span className="pt-1 text-neutral-700 dark:text-neutral-300">
                    {item}
                  </span>
                </li>
              ))}
            </ol>
          </div>
          <div>
            <h2 className="text-2xl font-semibold">Tips</h2>
            <div className="mt-4 grid gap-3">
              {route.practicalTips.map((tip) => (
                <p
                  key={tip}
                  className="border-l-2 border-neutral-950 pl-4 text-sm leading-6 text-neutral-700 dark:border-white dark:text-neutral-300"
                >
                  {tip}
                </p>
              ))}
            </div>
          </div>
          <AdBanner slot="beforeFaq" />
          <div>
            <h2 className="text-2xl font-semibold">Related tools</h2>
            <div className="mt-4 flex flex-wrap gap-2">
              {route.related.map((path) => (
                <Link
                  key={path}
                  to={path}
                  className="border border-neutral-300 px-3 py-2 text-sm hover:border-neutral-950 dark:border-neutral-700 dark:hover:border-white"
                >
                  {path.replace(/^\//, "").replace(/-/g, " ")}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
